import { TeamMember, Achievement } from '../types/TeamMember';

export const teamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'Janez Krajnc',
    position: 'Ustanovitelj in direktor',
    bio: 'Janez je tretja generacija družine Krajnc, ki nadaljuje tradicijo pridelave bučnega olja. Z več kot 30 leti izkušenj v oljarstvu je prava zakladnica znanja o tradicionalnih postopkih pridelave.',
    image: '/images/team/janez.jpg'
  },
  {
    id: '2',
    name: 'Marija Krajnc',
    position: 'Vodja proizvodnje',
    bio: 'Marija skrbi za kakovost vseh naših izdelkov. Njena strast do lokalnih surovin in tradicionalnih receptov zagotavlja, da vsak izdelek odraža bogato dediščino našega podjetja.',
    image: '/images/team/marija.jpg'
  },
  {
    id: '3',
    name: 'Matej Novak',
    position: 'Vodja razvoja izdelkov',
    bio: 'Matej združuje tradicionalno znanje z inovativnimi pristopi. Pod njegovim vodstvom smo razvili številne nove izdelke, ki spoštujejo našo dediščino, a prinašajo svežino na trg.',
    image: '/images/team/matej.jpg'
  },
  {
    id: '4',
    name: 'Ana Kovač',
    position: 'Vodja prodaje',
    bio: 'Ana s svojim pristopom in poznavanjem trga skrbi, da naši izdelki najdejo pot do pravih strank. Njeno delo je ključno za širjenje prepoznavnosti naše blagovne znamke.',
    image: '/images/team/ana.jpg'
  }
];

export const achievements: Achievement[] = [
  {
    id: '1',
    title: 'Ustanovitev Oljarne Krajnc',
    description: 'Začetek tradicije pridelave bučnega olja v družini Krajnc.',
    year: '1927',
    icon: 'History'
  },
  {
    id: '2',
    title: 'Nagrada za najboljše bučno olje',
    description: 'Prejeli smo zlato priznanje za kakovost našega tradicionalnega bučnega olja na nacionalnem tekmovanju.',
    year: '1985',
    icon: 'Award'
  },
  {
    id: '3',
    title: 'Razširitev proizvodnje',
    description: 'Posodobitev opreme z ohranitvijo tradicionalnih postopkov pridelave.',
    year: '1998',
    icon: 'Factory'
  },
  {
    id: '4',
    title: 'Nova linija izdelkov',
    description: 'Uvedba nove linije izdelkov iz bučnih semen in razširitev ponudbe.',
    year: '2010',
    icon: 'Package'
  },
  {
    id: '5',
    title: 'Ekološki certifikat',
    description: 'Pridobitev ekološkega certifikata za našo linijo ekoloških izdelkov.',
    year: '2015',
    icon: 'Leaf'
  },
  {
    id: '6',
    title: 'Mednarodna priznanja',
    description: 'Naši izdelki so prejeli priznanja na mednarodnih tekmovanjih v Avstriji in Nemčiji.',
    year: '2020',
    icon: 'Globe'
  }
];

export const companyHistory = {
  founding: {
    title: 'Ustanovitev in začetki',
    content: 'Zgodovina Oljarne Krajnc sega v leto 1927, ko je Franc Krajnc, dedek današnjega lastnika oljarne Janeza Krajnca, v Središču ob Dravi začel pridelavo bučnega olja. Svoje znanje in izkušnje je nato prenesel na sina Antona, ta pa je dejavnost predal svojemu potomcu Janezu, tako da je danes v Oljarni Krajnc že tretja generacija, znanje pa se prenaša iz roda v rod.',
    year: '1927-1950'
  },
  growth: {
    title: 'Rast in razvoj',
    content: 'V 80. in 90. letih prejšnjega stoletja je Oljarna Krajnc začela širiti svojo proizvodnjo, a vedno z mislijo na ohranjanje tradicionalnih postopkov. Kljub modernizaciji opreme so bili postopki pridelave olja še vedno isti kot pred desetletji, kar je zagotavljalo izjemno kakovost izdelkov in prepoznavnost blagovne znamke.',
    year: '1980-2000'
  },
  modern: {
    title: 'Sodobna Oljarna Krajnc',
    content: 'Danes Oljarna Krajnc nadaljuje družinsko tradicijo pod vodstvom Janeza Krajnca, ki združuje bogato dediščino s sodobnimi pristopi. Poleg tradicionalnega bučnega olja ponujamo široko paleto izdelkov iz bučnih semen, od namazov do pestojev in čokolad. Naša filozofija temelji na lokalnih surovinah, tradicionalnih postopkih in inovativnih izdelkih.',
    year: '2000-danes'
  }
};

export const mission = {
  title: 'Naše poslanstvo',
  content: 'Naše poslanstvo je ohranjanje bogate tradicije pridelave bučnega olja v Sloveniji, hkrati pa razvijanje novih, inovativnih izdelkov, ki sledijo sodobnim trendom zdrave prehrane. Zavezani smo k sodelovanju z lokalnimi pridelovalci, trajnostnemu razvoju in najvišji kakovosti vseh naših izdelkov.'
};

export const vision = {
  title: 'Naša vizija',
  content: 'Postati vodilni proizvajalec premium bučnega olja in sorodnih izdelkov v regiji, prepoznaven po izjemni kakovosti, inovativnosti in spoštovanju tradicije. Želimo, da naši izdelki postanejo sinonim za vrhunsko kulinarično doživetje in zdravo prehrano.'
};

export const values = [
  {
    title: 'Tradicija',
    description: 'Ohranjamo tradicionalne postopke pridelave, ki so se izkazali za najboljše že pred skoraj stoletjem.'
  },
  {
    title: 'Kakovost',
    description: 'Brez kompromisov sledimo najvišjim standardom kakovosti pri vseh naših izdelkih.'
  },
  {
    title: 'Lokalnost',
    description: 'Sodelujemo z lokalnimi pridelovalci in podpiramo lokalno gospodarstvo.'
  },
  {
    title: 'Inovativnost',
    description: 'Vedno iščemo nove načine, kako tradicijo povezati s sodobnimi trendi.'
  },
  {
    title: 'Trajnost',
    description: 'Zavezani smo k okolju prijaznim praksam in trajnostnemu razvoju.'
  }
];